import React from "react";
import { cx, ui } from "./ui";

export default function Card({ title, subtitle, right, children, className }) {
  return (
    <div className={cx(ui.card, className)}>
      <div className={ui.cardPad}>
        {(title || subtitle || right) ? (
          <div className="flex items-start justify-between gap-3">
            <div>
              {title ? <div className="text-base font-black tracking-tight">{title}</div> : null}
              {subtitle ? <div className={cx(ui.muted, "mt-1")}>{subtitle}</div> : null}
            </div>
            {right ? <div className="shrink-0">{right}</div> : null}
          </div>
        ) : null}

        <div className={title || subtitle || right ? "mt-4" : ""}>{children}</div>
      </div>
    </div>
  );
}
